
export default {
  PRODUITS_DEVANTCAISSE: "Panier_Produits_DevantCaisse",
  PANIER_PRODUITS: "Panier_Produits",
  MOBILE_PANIER_PRODUITS: "Mobile_Panier_Produits",
  PANIER_MEA: "Panier_MEA",
  MOBILE_PANIER_MEA: "Mobile_Panier_MEA"
}
